import React, { useState, useEffect } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton
} from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import WarningIcon from "@material-ui/icons/Warning";

const ConfirmationModal = ({ classes, confirmationModalState }) => {
  const [localTitleText, setLocalTitleText] = useState('');
  const [localContentText, setLocalContentText] = useState('');
  const [localWarningText, setLocalWarningText] = useState('');
  const { isModalOpen, handleConfirmation, handleCancellation, titleText, contentText, warningText, showCancel = true, confirmButtonText = 'Yes' } = confirmationModalState;
  useEffect(() => { // Use a local copy of text for display, only update on opening of modal. Prevents text from disappearing before animation completes, during modal close
    if (isModalOpen) {
      setLocalTitleText(titleText);
      setLocalContentText(contentText);
      setLocalWarningText(warningText);
    }
  }, [isModalOpen, titleText, contentText]);

  const handleClose = (e, reason) => {
    if (reason === 'backdropClick') return; // updated handling for disableBackdropClick
    handleCancellation();
  }
  
  return (
    <Dialog onClose={handleClose} open={isModalOpen} className={classes.dialog}>
      <DialogTitle>
        {localTitleText ? localTitleText : ''}
      </DialogTitle>
      <IconButton className={classes.closeButton} onClick={handleCancellation}>
        <ClearIcon fontSize="inherit" />
      </IconButton>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" style={{ whiteSpace: 'pre-line' }}>
          {localContentText ? localContentText : ''}
        </DialogContentText>
        {localWarningText &&
          <div>
            <WarningIcon className={classes.warningIcon} />
            <DialogContentText id="alert-dialog-description" style={{ verticalAlign: 'middle' }} component='span'>
              {localWarningText}
            </DialogContentText>
          </div>
        }
      </DialogContent>
      <DialogActions>
        {showCancel && <Button onClick={handleCancellation}>Cancel</Button>}
        <Button onClick={handleConfirmation} variant="contained" color="primary">{confirmButtonText}</Button>
      </DialogActions>
    </Dialog>
  )
}

const styles = theme => ({
  dialog: {
    minWidth: '200px',
    minHeight: '150px'
  },
  closeButton: {
    position: 'absolute',
    right: 0,
    top: 0,
    // backgroundColor: '#ffffff'
  },
  warningIcon: {
    fill: theme.palette.warning.text,
    verticalAlign: 'middle',
    marginRight: 4
  },
});

const mapState = state => ({
  confirmationModalState: state.appState.confirmationModalState
});

export default compose(
  withStyles(styles),
  connect(mapState)
)(ConfirmationModal);